import { render, staticRenderFns } from "./ActivationBriefAgreementsRouterView.vue?vue&type=template&id=1322ebd8&"
import script from "./ActivationBriefAgreementsRouterView.vue?vue&type=script&lang=js&"
export * from "./ActivationBriefAgreementsRouterView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports